import { createContext, useContext } from 'react'
import type { CinemaServiceInterface } from './cinema.service.interface'
import type { UrlServiceInterface } from './url.service.interface'

interface OmniaServiceContext {
    cinemaService: CinemaServiceInterface
    urlService: UrlServiceInterface
}

export const OmniaServiceContext = createContext<OmniaServiceContext | null>(null)

export const useOmniaServiceContext = () => useContext(OmniaServiceContext)
export const useCinemaService = () => useOmniaServiceContext()!.cinemaService
export const useUrlService = () => useOmniaServiceContext()!.urlService
